// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Cx5b_","image":"Header_image__UeAUN","name":"Header_name__Ac0NS","info":"Header_info__2YgQr","infoRow":"Header_infoRow__mEhnT"};